<template>
  <div class="company-auth">
    <h3>权限对象</h3>
    <h4 class="company-info">
      <div>公司：<span class="title">北京意园创新办公服务股份有限公司</span></div>
      <div class="button-content">
        <Button @click="handleCopyAll" icon="md-copy">复制全部</Button>
      </div>
    </h4>
    <Cell :accessList="accessList" :cellStatus="cellStatus"></Cell>
  </div>
</template>

<script>
  import Cell from './Cell.vue';
  export default {
    name: 'CompanyAuth',
    components: {
      Cell
    },
    data () {
      return {
        accessList: [],
        cellStatus: {
          editStatus: false,
          hideEditButton: true
        }
      }
    },
    mounted () {
      this.updateAuthList();
    },
    methods: {
      updateAuthList () { // 获取权限初始化数据
        this.$get(`/access/listCompanyAccess`).then(res => {
          if (res.success) {
            this.accessList = res.data;
          }
        })
      },
      handleCopyAll () {
        this.$Notice.success({ title: `复制成功！` });
        this.pasteStatus = false;
        sessionStorage.setItem('access', JSON.stringify(this.accessList));
      }
    }
  }
</script>

<style lang="less">
  @import "../../index.less";
  .company-auth{
    width: 80%;
    padding: 20px;
    h3{
      font-size: 16px;
    }
    .company-info{
      font-size: 14px;
      line-height: 2;
      text-indent: 20px;
      display: flex;
      justify-content: space-between;
      .title{
        color: @org-color;
      }
    }
  }
</style>
